import React, { HTMLAttributes, useCallback } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
import store from "store";

import XtSvg from "components/xt/svg";
import ModalAlert from "components/antd/modal/alert";
import Transfer from "components/pages/trade/_cmpt/modalTriggerBtn/transfer";
const { useTranslation } = Hooks;
const { getUrl } = Util;

import IconTransfer from "./icon/transfer";
import IconDeposit from "./icon/deposit";
import IconBuy from "./icon/buy";
import styles from "./index.module.scss";

interface Props extends Omit<HTMLAttributes<HTMLButtonElement>, "title"> {
  currency?: string;
}

const Deposit: React.FC<Props> = ({ className, currency }) => {
  const t = useTranslation();
  // const router = useRouter();
  const { isLogin,authInfo } = store.user;

  const handleClick = useCallback(() => {
    if (!isLogin) return;

    const modal = ModalAlert({
      className: styles.modal,
      title: t("trade.addAvailableBalance"),
      width: 640,
      footer: <></>,
      closable: true,
      closeIcon: <XtSvg icon={"close"} />,
      content: (
        <div className={styles.modalContent}>
          {
            (!authInfo || !authInfo.country || authInfo.country.code == 971) ? null : <Transfer currency={currency} onClick={() => modal.destroy()}>
              <div>
                <IconTransfer />
              </div>
              <div>
                <p>{t("trade.transfer")}</p>
                <div>{t("trade.transferTips")}</div>
              </div>
              <div>
                <span>➔</span>
              </div>
            </Transfer>
          }
          <a href={getUrl("/wallet/account/common/deposit?currency=usdt")}>
            <div>
              <IconDeposit />
            </div>
            <div>
              <p>{t("trade.deposit")}</p>
              <div>{t("trade.depositTips")}</div>
            </div>
            <div>
              <span>➔</span>
            </div>
          </a>
          <a href={getUrl("/otc/index")}>
            <div>
              <IconBuy />
            </div>
            <div>
              <p>{t("trade.buyOtc")}</p>
              <div>{t("trade.buyTips")}</div>
            </div>
            <div>
              <span>➔</span>
            </div>
          </a>
        </div>
      ),
    });
  }, [isLogin, currency, authInfo]);

  return (
    <button className={cx("btnTxt", className)} onClick={handleClick}>
      <XtSvg icon={"add"} />
    </button>
  );
};

export default observer(Deposit);
